var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.pages > 1
    ? _c(
        "nav",
        {
          staticClass: "pagination mt-2",
          attrs: { role: "navigation", "aria-label": "Products Navigation" },
        },
        [
          _c(
            "ul",
            { staticClass: "nav justify-content-center" },
            [
              _vm.currentPage != 1
                ? _c("li", [
                    _c(
                      "button",
                      {
                        staticClass: "page-numbers",
                        attrs: { "aria-label": _vm.prevPageText },
                        on: { click: _vm.loadPrevPage },
                      },
                      [_c("i", { staticClass: "fa fa-angle-left" })]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.pageRange, function (page) {
                return _c("li", { key: page }, [
                  _c(
                    "button",
                    {
                      staticClass: "page-numbers",
                      class: { current: _vm.isCurrentItem(page) },
                      attrs: {
                        "aria-label": `${_vm.transitionPageText} ${page}`,
                        "aria-selected": _vm.isCurrentItem(page),
                        disabled: page == _vm.currentPage,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.loadProductPage(page)
                        },
                      },
                    },
                    [_vm._v(_vm._s(page))]
                  ),
                ])
              }),
              _vm._v(" "),
              _vm.currentPage != _vm.pages
                ? _c("li", [
                    _c(
                      "button",
                      {
                        staticClass: "page-numbers",
                        attrs: { "aria-label": _vm.nextPageText },
                        on: { click: _vm.loadNextPage },
                      },
                      [_c("i", { staticClass: "fa fa-angle-right" })]
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }